import _ from "underscore";

import SimpleMarkdown from "@khanacademy/simple-markdown";

import type {MarkdownRules} from "../types.ts";

import {codeBlockFencedRule, codeBlockRule, codeRule} from "./code.tsx";
import {headingRule} from "./heading.tsx";
import {graphieRule, imageRule} from "./image.tsx";
import {linebreakRule} from "./line-break.tsx";
import {linkRule} from "./link.tsx";
import {orderedListRule, unorderedListRule} from "./list.tsx";
import {markRule} from "./mark.tsx";
import {mathBlockRule, mathRule} from "./math.tsx";
import {paragraphRule} from "./paragraph.tsx";
import {tableRule} from "./table.tsx";
import {textRule} from "./text.ts";

// Use the default rules in simple-markdown as a starting point and override
// the output rules to configure/customize how we render markdown. To see the
// rules supported by simple-markdown:
// https://github.com/Khan/perseus/blob/e05504d8ee11d5d3a21695bb31e9bc8fc664d708/packages/simple-markdown/src/index.js#L890
const defaultRules: Readonly<MarkdownRules> = _.extend(
    {},
    SimpleMarkdown.defaultRules,
    {
        ...SimpleMarkdown.defaultRules,
        blockMath: mathBlockRule,
        br: linebreakRule,
        codeBlock: codeBlockRule,
        fence: codeBlockFencedRule,
        heading: headingRule,
        graphie: graphieRule,
        image: imageRule,
        inlineCode: codeRule,
        link: linkRule,
        mark: markRule,
        math: mathRule,
        orderedList: orderedListRule,
        paragraph: paragraphRule,
        table: tableRule,
        text: textRule,
        unorderedList: unorderedListRule,
        // We override the original list rule and split it up into `orderedList`
        // and `unorderedList` so that they can be detected separately. This
        // is so something like the following will be recognized as two lists
        // instead of one:
        // 1.  One
        // 2.  Two
        // 3.  Three
        //
        // -   One
        // -   Two
        // -   Three
        list: undefined,
    },
);

export default defaultRules;
